"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsTableProperty = exports.resultsTablePropertyDefinition = void 0;
exports.resultsTablePropertyDefinition = {
    view: { label: 'Results Table' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'orderedProperties',
            argument: [
                'results-table-title',
                'results-table-columns',
                'results-table-rows',
            ],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'results-table',
};
const isResultsTableProperty = (prop) => {
    return prop.name === exports.resultsTablePropertyDefinition.name;
};
exports.isResultsTableProperty = isResultsTableProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy10YWJsZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3Jlc3VsdHMtdGFibGUucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBS2EsUUFBQSw4QkFBOEIsR0FBRztJQUM1QyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsZUFBZSxFQUFFO0lBQ2hDLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtRQUNEO1lBQ0UsSUFBSSxFQUFFLG1CQUFtQjtZQUN6QixRQUFRLEVBQUU7Z0JBQ1IscUJBQXFCO2dCQUNyQix1QkFBdUI7Z0JBQ3ZCLG9CQUFvQjthQUNyQjtTQUNGO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsbUJBQW1CO0lBQ3pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLGVBQWU7Q0FDVSxDQUFBO0FBVTFCLE1BQU0sc0JBQXNCLEdBQUcsQ0FBQyxJQUFrQixFQUFnQyxFQUFFO0lBQ3pGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxzQ0FBOEIsQ0FBQyxJQUFJLENBQUE7QUFDMUQsQ0FBQyxDQUFBO0FBRlksUUFBQSxzQkFBc0IsMEJBRWxDIn0=